var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name.includes('van-icon-'))?_c('van-icon',_vm._b({attrs:{"name":_vm.name.replace('van-icon-','')}},'van-icon',_vm.$attrs,false)):_c('svg',_vm._g({staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }